export interface Accumulator {
  participation_level: string;
  used: string;
  remaining: string;
  percent_used: number;
  note?: string;
}

export interface AccumulatorCard {
  applies_to: string;
  applies_to_birth_date: string;
  accumulators: Accumulator[];
}

export interface AccumulatorBlock {
  description?: string;
  accumulator_type: string;
  cards: AccumulatorCard[];
}

export interface AccumulatorProductCoverage {
  product_coverage_id: string;
  product_coverage_type: string;
  external_plan_name: string;
}

export interface AccumulatorMemberCoverage {
  member_coverage_id: string;
  member_full_name: string;
}

export interface AccumulatorBenefitsPeriod {
  id: string;
  start_date: string;
  end_date: string;
  _status: string;
}
